// components/common/OtpModal.jsx

import React from "react";

const OtpModal = ({
  isOpen,
  otpValues,
  otpError,
  otpInfoMessage,
  isLoading = false,
  title = "Enter OTP",
  subtitle = "We have sent an OTP to your phone no",
  onChange,
  onKeyDown,
  onVerify,
  onResend,
  inputRefs,
  verifyButtonText = "Verify",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/20 px-4">
      <div className="w-full max-w-[420px] rounded-[17px] bg-[#F5F5F5] px-12 pt-12 pb-[88px] font-['Work_Sans'] text-black shadow-[0_20px_45px_#00000026]">
        
        <h2 className="text-center text-2xl tracking-[-2%] font-semibold leading-7">
          {title}
        </h2>

        <p className="mt-3 text-center text-sm font-medium leading-4">
          {subtitle}
        </p>

        <p className="mt-3 leading-[21px]">
          Enter 4-digit OTP
        </p>

        <div className="mt-1 flex items-center gap-8">
          {otpValues.map((digit, index) => (
            <input
              key={index}
              ref={(element) => {
                inputRefs.current[index] = element;
              }}
              type="text"
              value={digit}
              onChange={(event) => onChange(index, event.target.value)}
              onKeyDown={(event) => onKeyDown(index, event)}
              inputMode="numeric"
              maxLength={1}
              className="h-12 w-[56px] rounded-lg border-[0.5px] border-[#923D8C] bg-[#FAFCFE] text-center text-xl font-semibold text-black focus:border-[#923D8C] focus:outline-none"
            />
          ))}
        </div>

        {otpError && (
          <p className="mt-2 text-center text-sm font-medium text-[#C62828]">
            {otpError}
          </p>
        )}

        {otpInfoMessage && (
          <p className="mt-2 text-center text-sm font-medium text-[#2E7D32]">
            {otpInfoMessage}
          </p>
        )}

        <button
          type="button"
          onClick={onVerify}
          disabled={isLoading}
          className="mt-3 h-8 w-full rounded-full tracking-[4%] bg-[#923D8C] font-medium text-white shadow-[0_6px_2px_-4px_#0E0E2C1A] disabled:cursor-not-allowed disabled:opacity-60"
        >
          {isLoading ? "Verifying..." : verifyButtonText}
        </button>

        <p className="mt-4 text-center text-[#8C8CA1]">
          Didn’t receive code?{" "}
          <button
            type="button"
            onClick={onResend}
            disabled={isLoading}
            className="text-[#923D8C] disabled:cursor-not-allowed disabled:opacity-60"
          >
            Resend OTP
          </button>
        </p>
      </div>
    </div>
  );
};

export default OtpModal;